import {
  fetchContent,
  postNullContent,
  wrapPromise,
} from "../../lib/fetchData";
import { SuspendPromise } from "../../lib/react-utils";
import { ICartReadContext } from "./cart-read-context";

export async function getCart(): Promise<ShoppingCart> {
  // Landing pages: let the hospital call establish the session first (see template-loader)
  await window.hgsHospitalSelection;
  return fetchContent("/api/Cart/GetCart");
}

export function adjustCartItem(request: CartItemRequest): Promise<string> {
  return postNullContent<CartItemRequest>("/api/Cart/UpdateCart", request);
}

/**
 * Add an item to the current cart (send API call)
 * @param request
 * @returns
 */
export function addItemToCart(request: CartItemRequest): Promise<string> {
  return postNullContent<CartItemRequest>("/api/Cart/AddItem", request);
}

export function fetchCartData(): SuspendPromise<ShoppingCart> {
  return wrapPromise(getCart());
}

export const ApiContext: ICartReadContext = {
  GetCart: getCart,
};
